import React from "react";
import { Outlet } from "react-router-dom";
const PropertyStagesRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PropertyStagesRoot;
